module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainApp"
    }
  }, [(_vm.$route.params.slug == 'startseite') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "position": "fixed",
      "z-index": "1000001",
      "cursor": "pointer",
      "transform-origin": "center center"
    },
    style: ({
      left: _vm.windowMargin * 1 + 'px',
      bottom: '50px',
      width: _vm.windowWidth - _vm.windowMargin * 2 + 'px'
    }),
    attrs: {
      "id": "featureBlock"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.downloadTermsVisible) ? _c('div', {
    style: ({
      width: _vm.windowWidth + 'px',
      height: _vm.windowHeight + 'px'
    }),
    attrs: {
      "id": "downloadTermsWrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.language == 'de') ? _c('div', {
    staticClass: "columns large-8 small-12 large-offset-2 margin-top-large"
  }, [_c('h2', [_vm._v("Hinweis zum Download")]), _vm._v(" "), _c('p', [_vm._v("\n            Gerne biete ich Ihnen die Bilder auf dieser Internetseite zum\n            Download an. Folgenden Bedingungen sind dabei zu beachten:\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Das zum Download bereit gestellt Bildmaterial ist urheberrechtlich\n            geschützt. Eine Nutzung ist nur mit ausdrücklicher Genehmigung\n            gestattet. Der Genehmigungsumfang ergibt sich in der Regel aus dem\n            Angebot.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Die Verwendung für Layout-Entwürfe ist bei Namensnennung\n            unmittelbar unter dem Bild unabhängig vom Vorliegen eines Angebotes\n            kostenfrei gestattet. Bei Unsicherheiten über den genehmigten\n            Nutzungsumfang zögern Sie nicht mit einer Nachfrage.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Bei jeder unberechtigten (ohne Zustimmung erfolgten) Nutzung,\n            Verwendung, Wiedergabe oder Weitergabe des Bild­materials ist für\n            jeden Einzelfall eine Vertragsstrafe in Höhe des fünffachen\n            Nutzungshonorars gemäß den Honoraren der Mittelstandsgemeinschaft\n            Foto-Marketing zu zahlen, vorbehaltlich weitergehender\n            Schadensersatzansprüche.  \n            ")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-large text-center button-area"
  }, [_c('a', {
    on: {
      "click": _vm.cancelDownloadTerms
    }
  }, [_c('h3', [_vm._v("Abbrechen")])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.acceptDownloadTerms
    }
  }, [_c('h3', [_vm._v("Ich stimme zu")])])])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('div', {
    staticClass: "columns large-8 small-12 large-offset-2 margin-top-large"
  }, [_c('h2', [_vm._v("Legal note regarding downloads")]), _vm._v(" "), _c('p', [_vm._v("\n            I'm delighted that you are interested in making use of my images.\n            However, please note that a few conditions apply. \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            All images are subject to copyright, any download requires my\n            explicit approval.  The number of images that can be downloaded\n            depends on the offer made by each potential client.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Images may be used free of charge for draft layouts as long as my\n            name is clearly stated directly under each image. This may be done\n            regardless of any existing offer. Should you be unsure about the\n            number of images you are allowed to use, please don't hesitate to\n            get in touch.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Please note that any unauthorized use (i.e. without my explicit\n            consent), reproduction and sharing of my images will result in a\n            minimum fee amounting to five times the usage fee in accordance\n            with the fee recommendations of the Mittelstandsgemeinschaft\n            Foto-Marketing (MFM), subject to further claims for damages.  ")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-large text-center button-area"
  }, [_c('a', {
    on: {
      "click": _vm.cancelDownloadTerms
    }
  }, [_c('h3', [_vm._v("Cancel")])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.acceptDownloadTerms
    }
  }, [_c('h3', [_vm._v("I agree")])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hide-for-small-only hide-for-medium-only",
    style: ({
      height: _vm.windowHeight + 'px'
    }),
    attrs: {
      "id": "sidebar"
    }
  }, [_c('a', {
    staticClass: "menu-toggle",
    on: {
      "click": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [_c('img', {
    staticClass: "sidebar-icon",
    attrs: {
      "src": "/static/images/icons/HMJ-Menue.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-menu"
  }, [_c('ul', [_c('li', [(_vm.language == 'en') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("All Projects")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.language == 'de') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("Alle Projekte")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'index-category',
          params: {
            category: cat.slug
          }
        }
      }
    }, [_vm._v("\n                        " + _vm._s(cat.title[_vm.language]) + "\n                    ")])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "margin-top-medium"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'about'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.about[_vm.language]))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'clients'
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.clients[_vm.language]))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'making-of'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.makingOf[_vm.language]))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'contact'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.contact[_vm.language]))])], 1), _vm._v(" "), (_vm.language == 'de') ? _c('li', {
    staticClass: "margin-top-medium",
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_c('a', [_vm._v("En")])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('li', {
    staticClass: "margin-top-medium",
    on: {
      "click": function($event) {
        _vm.setLanguage('de')
      }
    }
  }, [_c('a', [_vm._v("De")])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleFullScreen
    }
  }, [(!_vm.fullscreen) ? _c('img', {
    staticClass: "full-screen-trigger",
    attrs: {
      "src": "/static/images/icons/HMJ-Full-Screen-Open.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fullscreen) ? _c('img', {
    staticClass: "full-screen-trigger",
    attrs: {
      "src": "/static/images/icons/HMJ-Full-Screen-Close.svg"
    }
  }) : _vm._e()])], 2)]), _vm._v(" "), (_vm.showNavArrows) ? _c('div', {
    staticClass: "side-nav"
  }, [_c('a', {
    staticClass: "cursor-up sidebar-cursor",
    on: {
      "click": _vm.prevPage
    }
  }, [_c('img', {
    staticClass: "sidebar-icon",
    attrs: {
      "src": "/static/images/icons/HMJ-Cursor-Up.svg"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "cursor-down sidebar-cursor",
    on: {
      "click": _vm.nextPage
    }
  }, [_c('img', {
    staticClass: "sidebar-icon",
    attrs: {
      "src": "/static/images/icons/HMJ-Cursor-Down.svg"
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.layout.orientation == 'landscape' && _vm.layout.type != 'large') ? _c('div', {
    staticClass: "mobile-navigation",
    style: ({
      height: _vm.layout.viewportHeight + 'px'
    }),
    attrs: {
      "id": "mobile-navigation-horizontal"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('img', {
    staticClass: "mobile-sandwich",
    attrs: {
      "src": "/static/images/icons/HMJ-Menue.svg"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'portrait' && _vm.layout.type != 'large') ? _c('div', {
    staticClass: "mobile-navigation",
    style: ({
      width: _vm.layout.viewportWidth + 'px'
    }),
    attrs: {
      "id": "mobile-navigation-vertical"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('img', {
    staticClass: "mobile-sandwich",
    attrs: {
      "src": "/static/images/icons/HMJ-Menue.svg"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.layout.mobileNavigation) ? _c('div', {
    style: ({
      width: _vm.layout.viewportWidth + 'px',
      height: _vm.layout.viewportHeight + 'px',
      top: _vm.mobileMenuTop + 'px',
      left: _vm.layout.offsetLeft + 'px'
    }),
    attrs: {
      "id": "mobile-navigation-menu"
    }
  }, [(_vm.layout.orientation == 'portrait') ? _c('div', {
    staticClass: "mobile-navigation-content portrait",
    class: {
      verySmall: _vm.isVerySmall
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [(_vm.language == 'en') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("All Projects")]) : _vm._e()], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [(_vm.language == 'de') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("Alle Projekte")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('li', {
      on: {
        "click": _vm.toggleMobileNav
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'index-category',
          params: {
            category: cat.slug
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(cat.title[_vm.language]) + "\n                ")])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "margin-top-medium",
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'about'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.about[_vm.language]))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'clients'
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.clients[_vm.language]))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'making-of'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.makingOf[_vm.language]))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'contact'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.contact[_vm.language]))])], 1), _vm._v(" "), (_vm.language == 'de') ? _c('li', {
    staticClass: "margin-top-medium",
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_c('a', [_vm._v("En")])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('li', {
    staticClass: "margin-top-medium",
    on: {
      "click": function($event) {
        _vm.setLanguage('de')
      }
    }
  }, [_c('a', [_vm._v("De")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'landscape') ? _c('div', {
    staticClass: "row mobile-navigation-content landscape"
  }, [_c('div', {
    staticClass: "columns small-4 small-offset-2 margin-top-large medium-4 medium-offset-2"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [(_vm.language == 'en') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("All Projects")]) : _vm._e()], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [(_vm.language == 'de') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("Alle Projekte")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('li', {
      on: {
        "click": _vm.toggleMobileNav
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'index-category',
          params: {
            category: cat.slug
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(cat.title[_vm.language]) + "\n                ")])], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns small-6 margin-top-large"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'clients'
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.about[_vm.language]))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'clients'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.clients[_vm.language]))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'making-of'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.makingOf[_vm.language]))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'page',
        params: {
          pageslug: 'contact'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.nav.contact[_vm.language]))])], 1), _vm._v(" "), (_vm.language == 'de') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_c('a', [_vm._v("En")])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setLanguage('de')
      }
    }
  }, [_c('a', [_vm._v("De")])]) : _vm._e()])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.layout.mobileNavigation) ? _c('div', {
    style: ({
      marginLeft: _vm.layout.offsetLeft + 'px',
      marginTop: _vm.layout.offsetTop + 'px'
    }),
    attrs: {
      "id": "mainContent"
    }
  }, [_c('router-view')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ba05136!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app.vue
// module id = 188
// module chunks = 2